/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEthernet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 9H8V3h8v6h-3v2h9v2h-3v2h3v6h-8v-6h3v-2H7v2h3v6H2v-6h3v-2H2v-2h9zm-3 8H4v2h4zm12 0h-4v2h4zM14 5h-4v2h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEthernet as Ethernet };
